import { useEffect, useState } from 'react';

import { IProduct } from '@interfaces';
import styles from '@components/common/products/product.styles';
import ProductService from '@v2/services/product.service';
import { WPImage } from '@v2/utils/image';


export default function ProductIngredients({ product }: { product?: IProduct }) {
    const [ingredients, setIngredients] = useState(product.ingredients);
    const [description, setDescription] = useState(product.ingredientsDescription);

    useEffect(() => {
        if (!product.ingredients) {
            ProductService
                .ingredients(product.id)
                .then(setIngredients);
        } else {
            setIngredients(product.ingredients);
        }

        setDescription(product.ingredientsDescription);
    }, [product]);

    return (
        <div className={styles.ingredients}>
            <div className="pdp-ingredients-wrapp animated"
                {...{ animations: "animate__animated animate__fadeInUp-home animate__delay-03s" }}>
                <h3>ingredients</h3>
                <h2>real science from real food</h2>
                <p>
                    {
                        description ||
                        <>
                            Our ingredients are sourced from farms that test both their soil and their crops for contaminants,
                            then we test them again before we craft them into Cerebelly products (then we test them again!).
                        </>
                    }
                </p>
                <div className="ingedients-list-images">
                    {ingredients &&
                        Object
                            .values(ingredients)
                            .filter((ingredient: any) => ingredient.isKey)
                            .map((ingredient: any, key: number) =>
                                key < 3 &&
                                <div className="ingredient" key={key}>
                                    <WPImage src={ingredient.image} alt={ingredient.title} />
                                    <span className="ingredient-title">{ingredient.title}</span>
                                </div>
                            )}
                </div>
            </div>
        </div>
    );
}